import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-basic-table',
  templateUrl: './basic-table.component.html',
  styleUrls :['./basic-table.component.scss']
})
export class BasicTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
